import {
    BlockNoteEditor,
    defaultProps,
    insertOrUpdateBlock,
} from "@blocknote/core";
import {
    createReactBlockSpec,
    DragHandleMenuProps,
    useBlockNoteEditor,
    useComponentsContext,
} from "@blocknote/react";
import { IconSeparator } from "@tabler/icons-react";
import { Separator } from "@/components/ui/separator";
import { color } from "framer-motion";
import { cn } from "@/lib/utils";

export const SeparatorBlock = createReactBlockSpec(
    {
        type: "separatorblock",
        propSchema: {
            backgroundColor: defaultProps.backgroundColor,
        },
        content: "none",
    },
    {
        render: ({ block, editor }) => {
            const { backgroundColor } = block.props;

            return (
                <div className="nobackground my-4 w-full !bg-transparent">
                    <Separator
                        id={block?.id}
                        className="w-full"
                        style={{ backgroundColor }}
                    />
                </div>
            );
        },
    }
);
export const insertSeparatorBlock = () => ({
    title: "Separator",
    group: "Advanced",
    onItemClick: (editor: BlockNoteEditor) => {
        insertOrUpdateBlock(editor, {
            // @ts-ignore
            type: "separatorblock",
        });
    },
    aliases: ["separator", "divider", "formatting"],
    icon: <IconSeparator />,
    subtext: "A separator to help divide content",
});
